<template>
  <div>
    <b-modal
        ref="exportConfirm"
        centered
        :title="$t('btn.basic.export')"
        size="lg"
        :ok-title="$t('btn.basic.export')"
        :cancel-title="$t('lbl.basic.cancel')"
        @ok="confirmExport(entity,filterState,queryApi)"
    >
      <div class="form-horizontal">
        <div class="row">
          <div class="col-xs-2">
            {{ $t('export.totalRows') }}<input type="text" class="form-control" v-model="totalRows" disabled="true"/>
          </div>&emsp;&emsp;&emsp;
          <div class="col-xs-2">
            {{$t('export.totalDown')}}<input type="text" class="form-control" v-model="paramList[0].value" :placeholder=totalRows />
          </div>
          <b-form-group
              id="synchronize-group"
              label="layout表头:"
              label-for="input-synchronize">
            <el-switch
                style="display: block"
                v-model="useCustomFields"
                active-color="#13ce66"
                inactive-color="#ff4949"
                active-text="layout表头">
            </el-switch>
          </b-form-group>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "em-table-export",
  props: {
    entity: {
      type: String
    },
    filterState: {
      type: String,
      defaultValue: "filter"
    },
    queryApi: {
      type: String,
      defaultValue: "findByFilter"
    },
    config: {
      type: Object
    },
    useCustomFieldsDefaultFlag: {
        type: Boolean,
        default: true
    },
    customVuexName: {
        type: String,
        defaultValue: ""
    }
  },
  data() {
    return {
      totalRows: 0,
      customFieldList: [],
      paramList: [
        {label: "export.perPageSize", value: ''}
      ],
      useCustomFields: this.useCustomFieldsDefaultFlag
    };
  },
  computed: {
    paramValue() {
      return name => this.paramList.filter(v => v.label === name)[0];
    }
  },
  watch: {
    config(newValue) {
      this.totalRows = newValue.totalRows <= 0 ? 0 : newValue.totalRows;
      this.customFieldList = newValue.customFieldList ? newValue.customFieldList.map(m => this.$t(m.label)+'/'+this.$t(m.key)) : [];
    }
  },
  methods: {
    recoverInitData() {
      const paramValue = this.paramValue;
      paramValue("export.perPageSize").value = '';
    },
    show() {
      this.recoverInitData();
      this.$refs.exportConfirm.show();
    },
    confirmExport(entity, filterState, queryApi) {
      const paramValue = this.paramValue;
      const totalReg = this.totalRows;
      const customVuexName = this.customVuexName

      const currentPage = 0;
      const numRegPag = (paramValue("export.perPageSize").value || totalReg);

      this.EmExport({
        entity,
        filterState,
        queryApi,
        exportParam: {
          currentPage,
          numRegPag,
          totalReg,
          customVuexName
        },
        customFieldList: this.useCustomFields ? this.customFieldList : [],
      });
    },
    ...mapActions("emBase", ["EmExport"])
  }
};
</script>
